module.exports = __webpack_public_path__ + "img/service-1-shouhou.1fd626be.png";